import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=85348284&scoped=true&"
import script from "./BillingAddress.vue?vue&type=script&lang=js&"
export * from "./BillingAddress.vue?vue&type=script&lang=js&"
import style0 from "./BillingAddress.vue?vue&type=style&index=0&id=85348284&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85348284",
  null
  
)

export default component.exports